import React from "react";
import excel from "../../images/excel.png";
import PatientDebitList from "./PatientDebitList";
import PaymentReportPagination from "./PaymentReportPagination";
import usePatientDebitReport from "./usePatientDebitReport";
import usePaymentPagination from "./usePaymentPagination";
import { downloadPaymentXlsx } from "./paymentExcel";
import { CELL_STYLE } from "./PaymentReportRow";

const ROWS_KEY = "providerpatientdebitreport";
const COLUMNS = ["Member ID", "Patient Name", "Date Of Birth"];

export default function PatientDebitStatus(props) {
    const data = usePatientDebitReport(props);
    const { offset, limit, setitems, pageBack, pageForward } = usePaymentPagination(data, ROWS_KEY);

    function handleDownloadClick() {
        const rows = [COLUMNS];

        if (data && data[ROWS_KEY]) {
            data[ROWS_KEY].forEach((patient) => {
                rows.push([patient.member_id, patient.first_name + " " + patient.last_name, patient.date_of_birth]);
            });
        }

        // Excel caps sheet names at 31 chars, so this is a trimmed form of the page title.
        downloadPaymentXlsx(rows, "Updated Virtual Debit Number", "PatientDebitCardInformation");
    }

    return (
        <div className="clear">
            <div className="col-sm-12 col-md-12 col-lg-12">
                <span style={{ float: "left" }}>
                    <p style={{ margin: 0 }}>
                            Please see below for a listing of your patients whose virtual co-pay debit card information has changed.
                    </p>
                </span>
                <span className="tooltip" style={{ float: "right" }}>
                    <a onClick={handleDownloadClick}>
                        <img src={excel} className="excel" />
                    </a>
                </span>
                <table style={{ marginTop: "0", marginBottom: "0" }} className="account">
                    <thead>
                        <tr className="list_header">
                            {COLUMNS.map((column) => (
                                <th key={column} align="left" style={CELL_STYLE}>
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <PatientDebitList data={data} offset={offset} limit={limit} />
                </table>
                <PaymentReportPagination
                    data={data}
                    rowsKey={ROWS_KEY}
                    offset={offset}
                    limit={limit}
                    setitems={setitems}
                    pageBack={pageBack}
                    pageForward={pageForward}
                />
            </div>
        </div>
    );
}


